import { useState, useEffect, useCallback, RefObject } from 'react';
import { toast } from 'react-toastify';

import * as E from '@pages/Equipment/Equipment.style';
import theme from '@styles/theme';
import useDnD from '@hooks/useDnD';
import { noticeListHeader } from '@lib/data';
import { NOTICE_DATA } from '@lib/DUMMY';

import { RegularFont } from '@components/styled/StyledComponents';
import TableHeader from '@components/share/Table/TableHeader';
import { EmptyTable, TableBody } from '@components/share/Table/table.style';
import { InfoSection } from '@components/share/Info/InfoSection';
import StyledTextarea from '@components/styled/StyledTextarea';
import StyledButton from '@components/styled/StyledButton';
import NoticeListRow from './NoticeListRow';

const NoticeSetting = () => {
    const [notice, setNotice] = useState('');
    const [noticeList, setNoticeList] = useState<any[]>([]);
    const [radioSelections, setRadioSelections] = useState<
        Record<string, boolean>
    >({});

    const { findList, moveList, drop } = useDnD(
        noticeList,
        setNoticeList,
        'id'
    );

    useEffect(() => {
        if (NOTICE_DATA.length) {
            setNoticeList(NOTICE_DATA);
        }
    }, []);

    const handleRadioButtons = useCallback(
        (radioKey: string, value: number) => {
            if (
                !value &&
                !window.confirm(
                    '사용중인 공지사항을 미사용으로 변경하시는 경우 플레이리스트에서 즉시 삭제 됩니다. 미사용으로 변경하시겠어요?'
                )
            ) {
                return;
            }
            // TODO: 추후 리졸버 적용
            try {
                setRadioSelections((prev) => {
                    return {
                        ...prev,
                        [radioKey]: !!value
                    };
                });
                toast.success(
                    `공지사항이 ${
                        value ? '사용중' : '미사용'
                    }으로 변경되었습니다.`
                );
            } catch (err) {
                console.error(err);
            }
        },
        []
    );

    const onDelete = (id: number) => {
        if (
            !window.confirm(
                '공지사항을 삭제하시면 복구가 불가능합니다. 정말 삭제하시겠어요?'
            )
        )
            return;
        try {
            toast.success('파일을 삭제했습니다.');
        } catch (err) {
            console.error(err);
        }
    };
    const onAdd = () => {
        if (!notice) return toast.warning('공지사항을 입력해주세요.');

        try {
            toast.success('공지사항이 추가되었습니다.');
        } catch (err) {
            console.error(err);
        }
    };

    const onSubmit = () => {
        if (Object.keys(radioSelections).length !== noticeList.length) {
            return toast.warning('사용 여부를 전부 선택해주세요.');
        }

        try {
            toast.success('저장되었습니다.');
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <InfoSection title="공지사항" ROW>
            <StyledTextarea
                title="공지사항"
                value={notice}
                onChange={(e) => setNotice(e.target.value)}
                placeholder="공지사항을 입력해주세요"
                maxLength={150}
                width={630}
                margin="0 0 24px"
            />
            <StyledButton
                title="추가하기"
                onClick={onAdd}
                width={305}
                fontColor={theme.colors.blackColor}
                bgColor={theme.colors.whiteColor}
                border={`${theme.colors.ultraLightGrayBorder} 1px solid`}
            />
            <RegularFont
                $margin="24px 0 12px"
                $fontColor={theme.colors.positiveBlue}
            >
                공지사항은 정렬 순서대로 재생됩니다.
            </RegularFont>
            <E.SectionWrapper $width="630px">
                <TableHeader
                    header={noticeListHeader}
                    bgColor={theme.colors.ultraLightGrayBorder}
                />
                <TableBody ref={drop as unknown as RefObject<HTMLUListElement>}>
                    {noticeList.length > 0 ? (
                        noticeList.map((data, index) => {
                            return (
                                <NoticeListRow
                                    key={`${index}-notice-list`}
                                    index={index}
                                    header={noticeListHeader}
                                    data={data}
                                    onChange={handleRadioButtons}
                                    onDelete={onDelete}
                                    radioGroup={radioSelections}
                                    radioKey={`image${data.id}`}
                                    moveList={moveList}
                                    findList={findList}
                                />
                            );
                        })
                    ) : (
                        <EmptyTable>재생할 플레이리스트가 없습니다.</EmptyTable>
                    )}
                </TableBody>
            </E.SectionWrapper>
        </InfoSection>
    );
};

export default NoticeSetting;
